import * as types from "../actions/actionTypes";
import { getAllEngagementsResponse, getEngagementByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const engagementEntity = createEntitySagas({
  entity: "engagement",
  endpoint: "engagements",
  label: "Engagement",
  scope: "company",
  injectCompanyId: true,
  computedFields: ["brandName","manufacturerName","coordinator","walletBalance","availableBalance","heldAmount","activeRequirements","activeOrders","pendingApprovals","lastActivity"],
  selectSlice: (state) => state.engagement,
  listKey: "engagements",
  types: {
    getAll: types.GET_ALL_ENGAGEMENTS,
    getById: types.GET_ENGAGEMENT_BY_ID,
    create: types.CREATE_ENGAGEMENT,
    update: types.UPDATE_ENGAGEMENT,
    remove: types.DELETE_ENGAGEMENT,
  },
  actions: { getAllResponse: getAllEngagementsResponse, getByIdResponse: getEngagementByIdResponse },
});

export const engagementSaga = engagementEntity.watcher;
